































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@/utils/common";
import GeneralVehicleSelect from "@/components/scope/general-vehicle-select.vue";
import BtnCheck from "@/components/scope/btn-check.vue";
import BtnCheckGroup from "@/components/scope/btn-check-group.vue";
import dayjs from "dayjs";
import { priceRulesEl, mobileRulesEl, partsQuantityRules, priceRules } from "@/utils/verify";

const staff = namespace("staff");
const customer = namespace("customer");
const serviceItem = namespace("service-item");
const service = namespace("service");
const parts = namespace("parts");
const partsCategory = namespace("parts-category");
const user = namespace("user");
const app = namespace("app");

@Component({
  components: { GeneralVehicleSelect, BtnCheck, BtnCheckGroup }
})
export default class ServiceEdit extends Vue {
  @app.Mutation setPBPX;
  @staff.Action getStaffList;
  @customer.Action getCustomerList;
  @customer.Action getCustomerDetail;
  @serviceItem.Action getServiceList;
  @serviceItem.Action getServiceDetail;
  @customer.Action saveCustomer;
  @service.Action createRetailOrder;
  @parts.Action getPartsInventoryList;
  @parts.Action getPartsDetail;
  @service.Action getOrderDetail;
  @service.Action updateOrder;
  @serviceItem.Action createService;
  @partsCategory.Action getCategoryList;
  @parts.Action createParts;
  @user.State userData;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  dayjs = dayjs;
  splitThousands = splitThousands;
  get breadData() {
    let typeStr = window._I18N.t("test.new-retail-service");
    return [
      { name: window._I18N.t("test.service-management"), path: "/service/index" },
      { name: this.isAdd ? typeStr : window._I18N.t("service.edit-service-information") }
    ];
  }
  get isAdd() {
    return this.$route.name === "serviceRetailAdd";
  }
  get orderType() {
    return "retail";
  }
  quitNext: any;
  shwoAddServiceModal: boolean = false; // 快捷添加服务modal框显示/隐藏
  shwoQuitConfirm: boolean = false;
  showMobileUsedTips: boolean = false;
  customerList: any[] = [];
  // 控制form disable状态
  formDisableStatus = {
    customerName: false,
    customerMobile: false
  };
  categoryCasProps: any = {
    label: "categoryName",
    value: "categoryCode"
  };
  newPartsData = {
    partsName: "",
    categoryCode: [],
    sellingPrice: "",
    status: "1"
  };
  handleAddParts() {
    this.orderFormData.partsDetail.push(Object.assign({}, this.definitionPartsData));
  }
  handleChooseCustomer(val) {
    if (!val) return;
    this.setCustomerData(val);
  }
  searchKey: string = "";
  handleSearchCustomer(val) {
    if (!val) {
      this.customerList = [];
      return;
    }
    this.searchKey = val;
    this.getCustomerList({
      pageSize: 20,
      pageNum: 1,
      searchKey: val
    }).then(data => {
      if (!data.data.list) {
        this.customerList = [];
      } else {
        const customerCodeArr = []; // 去重
        this.customerList = data.data.list.filter(item => {
          if (customerCodeArr.includes(item.customerCode)) {
            return false;
          } else {
            customerCodeArr.push(item.customerCode);
            return true;
          }
        });
      }
    });
  }
  customerDataByMobile: any = {};
  handleQueryCustomerByMobile() {
    if (!this.orderFormData.customerMobile) return;
    this.getCustomerDetail({
      mobile: this.orderFormData.customerMobile
    }).then(data => {
      if (data.data) {
        this.customerDataByMobile = data.data;
        if (!this.orderFormData.customerCode) {
          this.showMobileUsedTips = true;
        }
      } else {
        this.orderFormData.customerCode = "";
      }
    });
  }
  handleSetCustomerInfo() {
    this.orderFormData.customerName = this.customerDataByMobile.customerName;
    this.orderFormData.customerCode = this.customerDataByMobile.customerCode;
    this.showMobileUsedTips = false;
  }
  handleSearchBlur(event) {
    this.orderFormData.customerName = this.searchKey;
  }
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  advisorList: any[] = [{}];
  emptyToLine = emptyToLine;
  orderFormData: any = {
    orderAmount: "0",
    customerCode: "",
    customerMobile: "",
    customerName: "",
    partsDetail: []
  };
  customerFormRules: any = {
    customerName: [{ required: true, message: "请输入客户姓名", trigger: "change" }],
    customerMobile: [
      { required: true, message: "请输入客户手机号", trigger: "change" },
      { validator: this.validateMobile, trigger: "blur" }
    ]
  };
  validateMobile(rule, value, callback) {
    mobileRulesEl(value, callback);
  }
  definitionPartsData: any = {
    partsCode: "",
    partsName: "",
    quantity: "",
    sellingPrice: "",
    amount: "",
    remark: "",
    manual: true
  };
  partsList: any[] = [];
  get orderId() {
    return this.$route.params.id;
  }
  created() {
    this.setPBPX(100);
    this.init();
    this.handleAddParts();
  }
  async init() {
    this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
      this.orderFormData.advisorCode = this.userData.userCode;
    });
    await this.getPartsLists();
    if (!this.isAdd) {
      this.getOrderDetail({
        orderNo: this.orderId
      }).then(data => {
        this.orderFormData = data.data;
        this.orderFormData.customerOilVolume = Number(data.data.customerOilVolume) * 20;
        data.data.partsDetail.forEach(item => {
          if (
            !this.partsList.some(partsItem => {
              return partsItem.partsCode === item.partsCode;
            })
          ) {
            this.partsList.push({
              partsCode: item.partsCode,
              partsName: item.partsName
            });
          }
        });
        this.formDisableStatus.customerName = !!data.data.customerName;
        this.formDisableStatus.customerMobile = !!data.data.customerMobile;
      });
    } else {
      let customerCode = this.$route.query.customerCode;
      if (customerCode) {
        this.setCustomerData(customerCode);
      }
    }
  }
  handleLinkAddParts(index) {
    // 当前作业添加弹窗-1223注释
    const { href } = this.$router.resolve("/setting/parts-add");
    window.open(href);
  }
  // 确认退出
  confirmQuit() {
    this.quitNext();
  }
  getPartsLists(name = "") {
    this.getPartsInventoryList({
      pageNum: 1,
      pageSize: 20,
      partsName: name
    }).then(data => {
      this.partsList = data.data.list ? data.data.list : [];
    });
  }
  computedAmount(type, index) {
    let amount =
      (this.orderFormData.partsDetail[index].quantity || 0) * this.orderFormData.partsDetail[index].sellingPrice;
    this.orderFormData.partsDetail[index].amount = amount.toFixed(2);
    this.computedTotalAmount();
  }
  computedTotalAmount() {
    const partsTotal = this.orderFormData.partsDetail.reduce((preV, curV) => preV + Number(curV.amount), 0);
    if (Object.is(NaN, partsTotal)) {
      return this.$message.error(window._I18N.t("setting.enter-quantity-or-amount"));
    }
    this.orderFormData.orderAmount = partsTotal.toFixed(2);
  }
  searchParts(val) {
    this.getPartsLists(val);
  }

  clearParts() {
    // 清除未匹配的套餐零配件
    const selectedServiceGroupIndexArr = this.orderFormData.serviceDetail.map(item => {
      return item.groupServiceIndex;
    });
    for (let partsIndex = 0; partsIndex < this.orderFormData.partsDetail.length; partsIndex++) {
      let currentParts = this.orderFormData.partsDetail[partsIndex];
      // 是套餐中的零配件，并且下标在项目中不存在
      if (currentParts.serviceCode && !selectedServiceGroupIndexArr.includes(currentParts.groupServiceIndex)) {
        this.orderFormData.partsDetail.splice(partsIndex, 1);
        partsIndex--;
      }
    }
  }
  handleChooseParts(val, index) {
    // this.getPartsDetail({
    //   partsCode: val
    // }).then(data => {
    //   const partsData = data.data;
    //   this.orderFormData.partsDetail.splice(index, 1, partsData);
    //   this.computedAmount(2, index);
    // });
    let partsData = Object.assign(
      {},
      this.definitionPartsData,
      this.partsList.find(item => item.partsCode === val)
    );
    this.orderFormData.partsDetail.splice(index, 1, partsData);
    this.computedAmount(2, index);
  }
  submitForm(formName) {
    (this.$refs[formName] as any).validate(valid => {
      if (formName === "customerForm") {
        if (valid && this.checkAddData()) {
          if (this.isAdd) {
            this.addService();
          } else {
            this.editService();
          }
        } else {
          console.log("error submit!!");
        }
      }
    });
  }
  checkAddData(): boolean {
    if (this.orderType === "retail" && this.orderFormData.partsDetail.length < 1) {
      this.$message.error(window._I18N.t("service.add-least-one-widget"));
      return;
    }
    for (let index = 0; index < this.orderFormData.partsDetail.length; index++) {
      const element = this.orderFormData.partsDetail[index];
      if (!element.partsCode) {
        this.$message.error(window._I18N.t("setting.select-spare-parts"));
        return false;
      }
      if (!element.quantity) {
        this.$message.error(window._I18N.t("service.fill-number-spare-parts"));
        return false;
      }
      const checkPartsQty = partsQuantityRules(element.quantity);
      if (!checkPartsQty.success) {
        this.$message.error(checkPartsQty.msg);
        return false;
      }
      if (!element.isGroupParts && !element.sellingPrice) {
        this.$message.error(window._I18N.t("service.fill-unit-price-spare-parts"));
        return false;
      }
    }
    return true;
  }
  async addService() {
    let result;
    let saveHasError = false;
    const customerSaveData = {
      customerCode: this.orderFormData.customerCode || "",
      vehicle: null,
      customerName: this.orderFormData.customerName,
      mobile: this.orderFormData.customerMobile
    };
    this.btnStartLoading();
    const createResult = await this.saveCustomer(customerSaveData).catch(err => {
      this.btnStopLoading();
      saveHasError = true;
    });
    console.log("save用户结果", createResult);
    if (saveHasError) {
      return;
    }
    this.btnStartLoading();
    const createParams = Object.assign(this.orderFormData, {
      customerCode: createResult.data.customerCode
    });
    try {
      const result = await this.createRetailOrder(this.orderFormData);
      this.$message.success(this.$t("base.create-success") as string);
      this.$router.push(`/service/view/${result.data.orderNo}`);
      this.quitNext();
    } catch (e) {
      this.btnStopLoading();
    }
  }
  editService() {
    this.btnStartLoading();
    this.updateOrder(this.orderFormData)
      .then(data => {
        this.$message.success(this.$t("base.update-success") as string);
        this.$router.push(`/service/view/${this.orderId}`);
      })
      .finally(item => {
        this.btnStopLoading();
      });
  }
  deleteItem(key, index) {
    this.orderFormData[key].splice(index, 1);
  }

  setCustomerData(customerCode, vehicleCode?) {
    this.getCustomerDetail({
      customerCode: customerCode,
      vehicleCode: vehicleCode
    }).then(data => {
      const customerData = data.data;
      if (customerData) {
        this.orderFormData.customerCode = customerData.customerCode;
        this.orderFormData.customerName = customerData.customerName;
        this.orderFormData.customerMobile = customerData.mobile;
      } else {
        this.orderFormData.customerCode = "";
      }
    });
  }
}
